import React from 'react';
import { prop } from 'ramda';

import { Logo } from '@core/js/components/main/DefaultHeader/components/Logo/Logo';

import { SvgIcon } from '@interlayer/js/custom/components/common/SvgIcon';

import { MyBalance } from '@theme/js/components/main/DefaultHeader/components/MyBalance/MyBalance';

import * as hooks from '@core/js/components/main/DefaultHeader/hooks';
import { useUserSelector } from '@core/js/store/hooks';

import { triggerCloseLeftMenu, useHandleToggleLeftMenu } from '@interlayer/js/components/main/DefaultHeader/sun/helper';
import { AUTOMATED_TEST_IDS } from '@interlayer/js/custom/constants';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from './MobileHeader.scss';

export const MobileHeader: React.FC = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { handleToggleLeftMenu, isOpenLeftMenu } = useHandleToggleLeftMenu();

    return (
        <div onClick={triggerCloseLeftMenu} className={style.header}>
            <div className={style.info}>
                <Logo />
            </div>

            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <>
                            <MyBalance/>

                            <SvgIcon
                                className={style.accountIcon}
                                onClick={handleToggleLeftMenu}
                                type="my-account"
                                color="#ed1c24"
                            />
                        </>
                    )
                    : (
                        <SvgIcon
                            onClick={onLoginButtonClick}
                            className={clsx(
                                style.accountIcon,
                                AUTOMATED_TEST_IDS.login,
                                { [style.isOpenedSideMenu]: isOpenLeftMenu }
                            )}
                            type="my-account"
                            color="#646464"
                        />
                    )
                }
            </div>
        </div>
    );
};
